import { guard, sample } from 'effector';
import { EndpointTrackNotifier } from '@voximplant/websdk/modules/conference';
import { ConferenceEvents } from '@/store/conferenceEvents';
import { throttle } from '@/helpers/throttle';
import {
  reorderEndpointMedias,
  VAD_UPDATE_DELAY,
  $mediaSettings,
  updateVideoSettings,
  enableRemoteVideo,
  makeVideoFullscreen,
  $endpointVideoDisabledByUser,
  disableEndpointVideoByUser,
  enableEndpointVideoByUser,
  openFullScreen,
  $isAllIncomingVideoDisabled,
} from '@/store/endpointMedia/index';
import { RequestVideoSizePayload } from '@/services/ConferenceSignaling';
import { MediaSettingsStore } from '@/store/endpointMedia/MediaSettingsStore';
import { $endpointManager, updateEndpoints } from '@/store/webrtc/endpoints';
import { meetingStore } from '@/store/meeting';
import { isSharingVideoKind, SHARING_KINDS } from '@/helpers/pin';
import { Endpoint } from '@voximplant/websdk/modules/conference';
import { $canvas, $layoutType } from '@/store/layout';
import { handleRenderUpdate } from '@/store/webrtc/handleRenderUpdate';

/*const handleTilesOrderByLayout = (layout: Layout, tiles: RawOutput[]) => {
  console.log('endpointMedia store', 'handleTilesOrderByLayout get', { layout, tiles });
  const newTiles = layout.reorderTiles(tiles);
  console.log('endpointMedia store', 'handleTilesOrderByLayout newTiles', newTiles);
  const tileOrder = isTilesOrderChanged(tiles, newTiles) ? newTiles : tiles;
  console.log('endpointMedia store', 'handleTilesOrderByLayout return', tileOrder);
  return tileOrder;
};
sample({
  clock: [changeLayoutType, reorderEndpointMedias, toggleSharing],
  source: [$layout, $convertedMedia],
  fn: (stores) => handleTilesOrderByLayout(...stores),
  target: $convertedMedia,
});*/

ConferenceEvents.vad.watch(
  throttle(({ enabled }) => {
    if (enabled) {
      console.log('endpointMedia store', 'ConferenceEvents.watch', { enabled });
      reorderEndpointMedias();
    }
  }, VAD_UPDATE_DELAY)
);

/*$renderVideo.watch((composedVideo) => {
  console.log('$renderVideo', 'watch', composedVideo);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  throttle(updateVideoSettings(composedVideo), VIDEO_SIZE_UPDATE_DELAY);
});*/

$mediaSettings
  .on(makeVideoFullscreen, (mediaSettingsStore, endpointID) => {
    // request video in full HD for full screen video
    console.log('$mediaSettings', `makeVideoFullscreen for ID ${endpointID}`);
    const newStore = mediaSettingsStore;
    if (endpointID === 'local') return newStore;
    const firstKey = Object.keys(newStore[endpointID])[0]; // get dynamic video element key
    console.log('$mediaSettings', 'makeVideoFullscreen find firstKey ', firstKey);
    newStore[endpointID][firstKey].height = 1080;
    newStore[endpointID][firstKey].width = 1920;
    console.log('$mediaSettings', 'makeVideoFullscreen', { ...newStore });
    return { ...newStore };
  })
  .on(enableRemoteVideo, (store, { endpointId, active }) => {
    console.log('$mediaSettings', `enableRemoteVideo active is ${active}`);
    console.log('$mediaSettings', 'enableRemoteVideo for user', store[endpointId]);
    console.log('$mediaSettings', 'enableRemoteVideo get store', store);
    for (const mid in store[endpointId]) {
      if (store[endpointId][mid].kind.includes('video')) store[endpointId][mid].active = active;
    }
    console.log('$mediaSettings', 'enableRemoteVideo return', { ...store });
    return { ...store };
  })
  .on(openFullScreen, (store, endpointId) => {
    const videoElement = document.getElementById(endpointId);
    if (!videoElement) return;
    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    } else {
      videoElement.style.transform = 'scaleX(1)';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      videoElement.webkitRequestFullscreen(); /* for Safari */
    }
    makeVideoFullscreen(endpointId);
  });

/* const manageEndpoints = (mediaSettingsStore: MediaSettingsStore, endpointStore: any) => {
  console.log('$mediaSettings', 'manageEndpoints all endpoints', endpointStore.endpoints);
  const payload: ManageEndpointsPayload = endpointStore.endpoints.reduce((payload, endpoint) => {
    if (endpoint.id === 'local') return payload;
    const audio: string[] = [];
    for (const midKey in endpoint.mid) {
      if (endpoint.mid[midKey].includes('audio')) audio.push(midKey);
    }
    return { ...payload, [endpoint.id]: { audio, video: [] } };
  }, {});

  console.log('$mediaSettings', 'manageEndpoints find endpoint', payload);
  console.log('$mediaSettings', 'manageEndpoints mediaSettingsStore', mediaSettingsStore);
  for (const endpointIdStore in mediaSettingsStore) {
    for (const mid in mediaSettingsStore[endpointIdStore]) {
      const midMedia = mediaSettingsStore[endpointIdStore][mid];
      if (midMedia.active) payload[endpointIdStore].video.push(mid);
    }
  }
  console.log('endpointMedia store', 'manageEndpoints send to signaling', { payload });
  if (Object.keys(payload).length) ConferenceSignaling.send('manageEndpoints', { payload });
}; */

const requestVideoSize = (store: MediaSettingsStore) => {
  const payload: RequestVideoSizePayload = {};
  console.log('endpointMedia store', 'requestVideoSize started with', store);
  for (const endpointId in store) {
    for (const mid in store[endpointId]) {
      const midMedia = store[endpointId][mid];
      if (midMedia.active && midMedia.kind.includes('video')) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        payload[endpointId] = { [mid]: [midMedia.width, midMedia.height] };
      }
    }
  }
  console.log('endpointMedia store', 'requestVideoSize send to signaling', { payload });
  // if (Object.keys(payload).length) ConferenceSignaling.send('requestVideoSize', { payload });
};

const changeVideoSettings = sample({
  clock: [makeVideoFullscreen, updateVideoSettings],
  source: $mediaSettings,
});
changeVideoSettings.watch(requestVideoSize);

$mediaSettings.watch((store) => {
  console.log('$mediaSettings', 'watch', store);
  // manageEndpoints(store, $endpoints.getState());
});

$endpointVideoDisabledByUser
  .on(disableEndpointVideoByUser, (store, endpointIds) => {
    if (!endpointIds) return;
    return store.concat(endpointIds);
  })
  .on(enableEndpointVideoByUser, (store, endpointIds) =>
    store.filter((endpointId) => !endpointIds.includes(endpointId))
  );

const endpointsChanged = sample({
  clock: $endpointManager,
  source: [meetingStore, $endpointVideoDisabledByUser, $endpointManager],
});

endpointsChanged.watch((source) => {
  const [meeting, videoDisabledByUser, tilerArea] = source;

  tilerArea.forEach(({ width, height, stream }) => {
    const endpointId = stream.id;
    const endpoint: Endpoint | undefined = meeting?.meeting?.endpointsMap.value?.[endpointId];

    if (!endpoint || videoDisabledByUser.includes(endpointId)) return;

    const isOverflowed = !width && !height;

    if (isOverflowed && endpoint.videoStatus.value === 'enabled') {
      endpoint.enableVideo(false);
    }

    if (!isOverflowed && endpoint.videoStatus.value === 'disabledByUser') {
      endpoint.enableVideo(true);
    }
  });
});

EndpointTrackNotifier.watchTrackChanges((endpoint, mediaMap) => {
  Object.values(mediaMap).forEach((description) => {
    if (isSharingVideoKind(description.kind) && endpoint.videoStatus.value === 'disabledByUser') {
      enableEndpointVideoByUser([endpoint.id]);
      endpoint.enableVideo(true);
    }
  });
});

const newEndpointIsNotDisabled = guard({
  clock: $endpointManager,
  filter: $isAllIncomingVideoDisabled,
});

sample({
  clock: newEndpointIsNotDisabled,
  source: [$endpointManager, meetingStore, $endpointVideoDisabledByUser],
  fn: ([endpointManager, { meeting }, endpointVideoDisabledByUser]) => {
    const endpointIds: string[] = endpointManager.map(({ stream: { id } }) => id);

    return endpointIds.filter((id) => {
      const endpoint: Endpoint | undefined = meeting?.endpointsMap.value?.[id];
      const isMeetingHasEndpoint = Boolean(endpoint);
      const isEndpointAlreadyDisabled = endpointVideoDisabledByUser.includes(id);
      const isSharingEndpoint = SHARING_KINDS.includes(endpoint?.video?.kind || '');

      return isMeetingHasEndpoint && !isEndpointAlreadyDisabled && !isSharingEndpoint;
    });
  },
  target: disableEndpointVideoByUser,
});

sample({
  clock: [$canvas, $layoutType],
  source: [$endpointManager, $canvas, meetingStore],
  fn: ([endpoints, canvas, { meeting }]) => {
    if (!meeting) return;

    return handleRenderUpdate(canvas, endpoints, meeting);
  },
  target: updateEndpoints,
});
